<header class="modal-header px-4 bg-white border-bottom-0">
  <h5 class="modal-title" id="modal-basic-title font-weight-bold">
    {{ asignar ? "Asignar sanción" : "Anular sanción" }}
  </h5>
  <button type="button" class="close" (click)="dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</header>
<section class="modal-body">
  <div class="p-2">
    <form [formGroup]="formAsignarSancion">
      <ng-container *ngIf="asignar === true">
        <div class="form-group">
          <label class="small text-secondary required" for="nit"
            >Texto a mostrar en el certificado</label
          >
          <input
            id="titulo"
            formControlName="titulo"
            class="form-control form-control-sm"
          />
        </div>
        <div class="row">
          <div class="form-group col-md-6 col-sm-12">
            <label class="small text-secondary required" for="nit"
              >Fecha de inicio</label
            >
            <div class="input-group">
              <input
                class="form-control form-control-sm"
                formControlName="fecha_inicio_sancion"
                placeholder="yyyy/mm/dd"
                ngbDatepicker
                #fin1="ngbDatepicker"
                [maxDate]="calendar.getToday()"
                readonly
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary calendar"
                  (click)="fin1.toggle()"
                  type="button"
                ></button>
              </div>
            </div>
          </div>
          <div class="form-group col-md-6 col-sm-12">
            <label class="small text-secondary" for="nit">Fecha fin</label>
            <div class="input-group">
              <input
                class="form-control form-control-sm"
                formControlName="fecha_fin_sancion"
                placeholder="yyyy/mm/dd"
                ngbDatepicker
                #fin2="ngbDatepicker"
                [minDate]="fechaActual"
                readonly
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary calendar"
                  (click)="fin2.toggle()"
                  type="button"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="form-group">
        <label class="small text-secondary required" for="nit">Motivo</label>
        <textarea
          id="motivo"
          formControlName="motivo"
          class="form-control form-control-sm"
          rows="4"
        ></textarea>
      </div>
      <ng-container *ngIf="!file; else documento">
        <div class="form-group border-dashed py-3 mb-4">
          <div class="row">
            <div class="col-12 text-center">
              <img
                width="85px"
                height="66px"
                src="../../../../../../../assets/icons/upload.png"
              />
            </div>
            <div class="col-12 text-center">
              <label class="small text-secondary" for="nit"
                >Selecciona un archivo PDF menor de 15MB</label
              >
            </div>
            <div class="col-12 text-center">
              <button
                class="btn btn-outline-primary"
                (click)="adjuntarArchivo.click()"
              >
                Subir
              </button>
              <input
                #adjuntarArchivo
                type="file"
                [hidden]="true"
                formControlName="archivo"
                [accept]="extensiones"
                (change)="onFileInput($event)"
              />
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #documento>
        <div class="form-group content-archivo mt-1 py-2 mb-4">
          <div class="row">
            <div class="col-10 centrar-izquierda">
              <img
                width="38"
                height="39"
                class="ml-2"
                src="../../../../../../../assets/icons/doc.png"
              />
              <div class="col-12 pl-1">
                <label class="col-12 p-0 m-0">{{ file.name }}</label>

                <label class="small col-12 text-secondary p-0 m-0" for="nit">{{
                  file.size < 1048576
                    ? (file.size / 1024).toFixed(2) + " KB"
                    : (file.size / 1048576).toFixed(2) + " MB"
                }}</label>
              </div>
            </div>
            <div class="col-2 centrar-boton">
              <button type="button" class="btn btn-link" (click)="cancel()">
                <img
                  width="30"
                  height="30"
                  src="../../../../../../../assets/icons/cancel_icon.png"
                  class="pointer"
                  alt="Eliminar"
                />
              </button>
            </div>
          </div>
        </div>
      </ng-template>
      <footer class="text-right">
        <button
          class="btn btn-outline-primary modal-tipo-rnt-btn-inicio-outline mr-3 border-0"
          (click)="dismiss()"
        >
          Cancelar
        </button>
        <button
          (click)="sendForm()"
          class="btn btn-primary m-auto"
          [disabled]="!formAsignarSancion.valid"
        >
          {{ asignar ? "Asignar" : "Inactivar" }}
        </button>
      </footer>
    </form>
  </div>
</section>
